import React, { useState, useEffect, useRef, useCallback } from "react";
import Sidebar from "../layout/Sidebar";
import "./Chat.css";
import { X} from "lucide-react";
import {InfoCircle, PageFlip, ArrowUpRight, LightBulbOn,Internet, Attachment, Copy, ThumbsDown,ThumbsUp, Check, NavArrowDown} from 'iconoir-react';
import axios from "axios";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";

const handleFileClickbak = async (file) => {
  if (!file) return;

  try {
    let fileUrl = "";

    if (typeof file === "string") {
      // This is the blob path
      const blobPath = file;
      
      // Check if it's already a full URL
      if (blobPath.startsWith('http://') || blobPath.startsWith('https://') || blobPath.startsWith('blob:')) {
        fileUrl = blobPath;
      } else {
        // Get token from cookies
        const cookies = document.cookie.split(';').reduce((acc, cookie) => {
          const [key, value] = cookie.trim().split('=');
          acc[key] = value;
          return acc;
        }, {});
        
        const token = cookies.sessionToken || cookies.SESSION_TOKEN || cookies.token;
        
        if (!token) {
          throw new Error('Session token not found. Please login again.');
        }

        // Use POST request to send blob path in body with authorization
        const response = await axios.post(
          `${process.env.REACT_APP_PORTAL_DESTINATION}getFile`,
          {
            filePath: blobPath
          },
          {
            headers: { 
              'Content-Type': 'application/json',
              'Authorization': `${token}`
            }
          }
        );
        
        if (response.data && response.data.fileUrl) {
          fileUrl = response.data.fileUrl;
        } else {
          throw new Error('Invalid response from server');
        }
      }
    } else if (file instanceof File || file instanceof Blob) {
      // This is a new file - create object URL
      fileUrl = URL.createObjectURL(file);
    } else {
      console.warn("❌ Unsupported file type:", file);
      Swal.fire({
        icon: 'warning',
        title: 'Format Tidak Didukung',
        text: 'Tipe file tidak dikenali.',
        confirmButtonColor: '#3085d6',
      });
      return;
    }

    // Open file in new window/tab
    const newWindow = window.open(fileUrl, '_blank', 'noopener,noreferrer');
    
    if (!newWindow) {
      throw new Error('Popup diblokir! Izinkan popup untuk situs ini.');
    }
    
    // Clean up object URL after a delay if it's a blob URL
    if (fileUrl.startsWith('blob:')) {
      setTimeout(() => {
        URL.revokeObjectURL(fileUrl);
      }, 1000);
    }
    
  } catch (err) {
    console.error("❌ Gagal membuka file:", err);
    
    let errorMessage = 'Terjadi kesalahan saat mencoba membuka file.';
    
    if (err.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      if (err.response.status === 401) {
        errorMessage = 'Sesi telah berakhir. Silakan login kembali.';
      } else if (err.response.status === 404) {
        errorMessage = 'File tidak ditemukan di server.';
      } else if (err.response.status === 403) {
        errorMessage = 'Anda tidak memiliki izin untuk mengakses file ini.';
      } else {
        errorMessage = `Error server: ${err.response.status}`;
      }
    } else if (err.request) {
      // The request was made but no response was received
      errorMessage = 'Tidak ada respon dari server. Periksa koneksi internet Anda.';
    } else if (err.message.includes('Session token')) {
      errorMessage = err.message;
    }
    
    Swal.fire({
      icon: 'error',
      title: 'Gagal Membuka File',
      text: errorMessage,
      confirmButtonColor: '#d33',
    });
  }
};
const handleFileClick = async (file) => {
  if (!file) return;

  // First handle blob/file objects immediately (synchronous)
  if (file instanceof File || file instanceof Blob) {
    const fileUrl = URL.createObjectURL(file);
    const newWindow = window.open(fileUrl, '_blank', 'noopener,noreferrer');
    
    if (!newWindow) {
      Swal.fire({
        icon: 'error',
        title: 'Popup Diblokir',
        text: 'Izinkan popup untuk situs ini atau gunakan Ctrl+Klik.',
        confirmButtonColor: '#d33',
      });
      return;
    }
    
    // Clean up later
    setTimeout(() => URL.revokeObjectURL(fileUrl), 1000);
    return;
  }

  // For string/file paths - show loading and handle async
  try {
    const cookies = document.cookie.split(';').reduce((acc, cookie) => {
      const [key, value] = cookie.trim().split('=');
      acc[key] = value;
      return acc;
    }, {});
    
    const token = cookies.sessionToken || cookies.SESSION_TOKEN || cookies.token;
    
    if (!token) {
      throw new Error('Session token not found. Please login again.');
    }

    // Show loading state
    Swal.fire({
      title: 'Memuat file...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    // Get file URL from server
    const response = await axios.post(
      `${process.env.REACT_APP_PORTAL_DESTINATION}getFile`,
      {
        filePath: typeof file === 'string' ? file : file.filePath
      },
      {
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `${token}`
        }
      }
    );
    
    if (!response.data || !response.data.fileUrl) {
      throw new Error('Invalid response from server');
    }
    
    const fileUrl = response.data.fileUrl;
    
    // Close loading
    Swal.close();
    
    // IMPORTANT: Open in current window instead of popup
    if (file?.includes('chat_uploads')) {
      window.open(fileUrl, '_blank', 'noopener,noreferrer');
    } else {
      const filestring = `${process.env.REACT_APP_PORTAL_DESTINATION}${file}`
      window.open(filestring, '_blank', 'noopener,noreferrer');
    }
        
    // Option 2: Or use a link element (more reliable)
    // const link = document.createElement('a');
    // link.href = fileUrl;
    // link.target = '_blank';
    // link.rel = 'noopener noreferrer';
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
    
  } catch (err) {
    Swal.close(); // Close loading if open
    
    console.error("❌ Gagal membuka file:", err);
    
    let errorMessage = 'Terjadi kesalahan saat mencoba membuka file.';
    
    if (err.response) {
      if (err.response.status === 401) {
        errorMessage = 'Sesi telah berakhir. Silakan login kembali.';
      } else if (err.response.status === 404) {
        errorMessage = 'File tidak ditemukan di server.';
      } else if (err.response.status === 403) {
        errorMessage = 'Anda tidak memiliki izin untuk mengakses file ini.';
      } else {
        errorMessage = `Error server: ${err.response.status}`;
      }
    } else if (err.request) {
      errorMessage = 'Tidak ada respon dari server. Periksa koneksi internet Anda.';
    } else if (err.message.includes('Session token')) {
      errorMessage = err.message;
    } else if (err.message.includes('Popup')) {
      errorMessage = 'Browser memblokir popup. Izinkan popup untuk situs ini atau gunakan Ctrl+Klik.';
    }
    
    Swal.fire({
      icon: 'error',
      title: 'Gagal Membuka File',
      text: errorMessage,
      confirmButtonColor: '#d33',
    });
  }
};
const renderFilePreview = (file, isBubble = false, fileindex = 0, idx = 1, fileName = "") => {
  if (!file) return null;

  let fileUrl = "";

  try {
    if (typeof file === "string") {
      
      // This is a file path from historical data
      fileUrl = file;
      if (fileName == "") fileName = file.split("/").pop() || "unknown";
      /*
      // If it's a relative path, make it absolute
      if (fileUrl.startsWith("/")) {
        fileUrl = `${process.env.REACT_APP_PORTAL_DESTINATION || ''}${fileUrl}`;
      }
      */
    } else if (file instanceof File || file instanceof Blob) {
      // This is a new file being uploaded
      fileUrl = URL.createObjectURL(file);
      if (fileName == "") fileName = file.name || "untitled";
    } else {
      return null;
    }
  } catch (err) {
    console.warn("❌ Gagal buat preview file:", err);
    return null;
  }

  const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(fileName);
  const isPDF = /\.pdf$/i.test(fileName);
  const isDoc = /\.(doc|docx)$/i.test(fileName);
  const isXls = /\.(xls|xlsx)$/i.test(fileName);

  let iconSrc = "/dist/img/filesicon/other.png";
  if (isPDF) iconSrc = "/dist/img/filesicon/pdf.png";
  else if (isDoc) iconSrc = "/dist/img/filesicon/word.png";
  else if (isXls) iconSrc = "/dist/img/filesicon/excel.png";

  return (
    <div
      key={fileindex + idx}
      className={`file-preview ${isBubble ? "file-preview-bubble" : ""}`}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        background: "#f5f8ff",
        padding: "8px 10px",
        borderRadius: "10px",
        marginTop: isBubble ? "6px" : "10px",
        maxWidth: isBubble ? "240px" : "260px",
        cursor: "pointer", // Add cursor pointer to indicate clickable
        transition: "background-color 0.2s ease",
      }}
      onClick={() => handleFileClick(file)}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "#e6eeff";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "#f5f8ff";
      }}
    >
      {isImage ? (
        <img
          src={fileUrl}
          alt={fileName}
          style={{
            width: isBubble ? "140px" : "60px",
            height: isBubble ? "auto" : "60px",
            objectFit: "cover",
            borderRadius: "8px",
          }}
        />
      ) : (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <img src={iconSrc} alt="file icon" style={{ width: "28px" }} />
          <span
            style={{
              fontSize: "13px",
              color: "#2b6cb0",
              wordBreak: "break-all",
            }}
          >
            {fileName}
          </span>
        </div>
      )}
    </div>
  );
};

const Chat = () => {
  const cookies = new Cookies();
  const [showUpdate, setShowUpdate] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const [masterChatList, setMasterChatList] = useState([]);
  const [promptSuggest, setPromptSuggest] = useState([]);
  const [message, setMessage] = useState("");
  const [globeOn, setGlobeOn] = useState(true);
  const [showSources, setShowSources] = useState(false);
  const [selectedSources, setSelectedSources] = useState({
    "int-befa": 0,
    "int-ict": 0,
    "int-smo": 0,
    "int-hcga": 0,
    "int-sales": 0,
    "int-trelation": 0,
    "int-hse": 0,
  });
  const [notification, setNotification] = useState(false);
  const [copiedIndex, setCopiedIndex] = useState(-1);
  const [isTyping, setIsTyping] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [chatList, setChatList] = useState([]);
  const [hovered, setHovered] = useState(false);
  const menuRef = useRef(null);
  const modelRef = useRef(null);
  const textareaRef = useRef(null);
  const userData = cookies.get("sessionData") || {};
  const [selectedMasterID, setSelectedMasterID] = useState(0);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFiles2, setSelectedFiles2] = useState([]);
  const aiIndexRef = useRef(null);

  const [internalSources, setInternalSources] = useState([
    { key: "int-befa", label: "Data Internal BeFa" },
  ]);

  const [aiModelPick, setAiModelPick] = useState([
    { key: "azureai|gpt-4.1", label: "gpt-4.1", detail:"Old Azure Model gpt 4.1 Old Azure Model gpt 4.1 Old Azure Model gpt 4.1 Old Azure Model gpt 4.1 " },
  ]);

  const [selectedAiModel, setSelectedAiModel] = useState("");
  const [showAiModelPopup, setShowAiModelPopup] = useState(false);
  const [modelHovered, setModelHovered] = useState(false);

  // Notification function
  const showTemporaryNotification = () => {
    setNotification(true);
    setTimeout(() => {
      setNotification(false);
    }, 2000);
  };

  const selectedModel = aiModelPick.find(
    (m) => m.key === selectedAiModel
  );

  const allowedDepartments = [1, 7, 25];

  const canPickAiModel = userData?.divisi?.some(
    (d) => allowedDepartments.includes(d.department_id)
  );

useEffect(() => {
  fetchModelOptions();
}, []);
  
const fetchModelOptions = async () => {
  
  const token = cookies.get("sessionToken");
  if (!token) return;

  try {
    const res = await axios.get(
      `${process.env.REACT_APP_PORTAL_DESTINATION}model-options`,
      { headers: { Authorization: `${token}` } }
    );
    if (res.data.status === 'success') {
      setAiModelPick(res.data.data);

      // ✅ default = first row (lowest id)
      if (res.data.data.length > 0) {
        setSelectedAiModel(res.data.data[0].key);
      }

      /*
      //debug for ict smo hc to default to second AI model
      userData.divisi.forEach((d) => {
        if (d.department_id == 1 || d.department_id == 7 || d.department_id == 25) {
          console.log("ict smo hc change to nano enter");
          setSelectedAiModel(res.data.data[1].key)
        }
      });
      */
    }
  } catch (err) {
    console.error("❌ Gagal Send Response:", err);
  }
};

const copySingleMessageBak = (content, index) => {
  // Create a temporary div to parse HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = content;
  
  // Preserve line breaks
  const brToNewLine = (htmlElement) => {
    // Replace <br> tags with newlines
    const brElements = htmlElement.getElementsByTagName('br');
    while (brElements.length > 0) {
      brElements[0].parentNode.replaceChild(
        document.createTextNode('\n'), 
        brElements[0]
      );
    }
    
    // Replace <p> tags with newlines
    const pElements = htmlElement.getElementsByTagName('p');
    const pArray = Array.from(pElements);
    pArray.forEach(p => {
      if (p.nextSibling) {
        p.parentNode.insertBefore(document.createTextNode('\n'), p.nextSibling);
      }
    });
    
    // Handle divs as well if needed
    const divElements = htmlElement.getElementsByTagName('div');
    const divArray = Array.from(divElements);
    divArray.forEach(div => {
      if (div.nextSibling && (div.className.includes('message') || div.className.includes('content'))) {
        div.parentNode.insertBefore(document.createTextNode('\n'), div.nextSibling);
      }
    });

    return htmlElement;
  };
  
  // Process the HTML to preserve formatting
  const processedElement = brToNewLine(tempDiv);
  
  // Get clean text with preserved line breaks
  let cleanText = processedElement.textContent || processedElement.innerText || '';
  
  // Clean up multiple newlines
  cleanText = cleanText
    .replace(/\n\s*\n\s*\n/g, '\n\n') // Replace 3+ newlines with 2
    .replace(/^\s+|\s+$/g, '') // Trim whitespace
    .replace(/\s*\n\s*/g, '\n') // Clean whitespace around newlines
    .replace(/[ \t]+/g, ' '); // Collapse multiple spaces
  
  // Copy to clipboard
  navigator.clipboard.writeText(cleanText)
    .then(() => {
      showTemporaryNotification(`Message ${index + 1} copied!`);
      setCopiedIndex(index); // Set the copied index
      // Reset after 2 seconds
      setTimeout(() => {
        setCopiedIndex(-1);
      }, 2000);
    })
    .catch(err => {
      console.error('Copy failed:', err);
      showTemporaryNotification('Failed to copy message', 'error');
    });
};

const copySingleMessageBak2 = (content, index) => {
  // Create a temporary div to parse HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = content;
  
  // Function to convert HTML to formatted plain text
  const htmlToFormattedText = (element) => {
    let text = '';
    
    // Process child nodes
    const nodes = element.childNodes;
    
    for (const node of nodes) {
      if (node.nodeType === Node.TEXT_NODE) {
        text += node.textContent;
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const tagName = node.tagName.toLowerCase();
        
        switch (tagName) {
          case 'br':
            text += '\n';
            break;
            
          case 'p':
          case 'div':
          case 'section':
          case 'article':
            text += htmlToFormattedText(node) + '\n\n';
            break;
            
          case 'ol':
            let olIndex = 1;
            const olItems = node.querySelectorAll('li');
            olItems.forEach((li, idx) => {
              text += `${olIndex + idx}. ${htmlToFormattedText(li).trim()}\n`;
            });
            text += '\n';
            break;
            
          case 'ul':
            const ulItems = node.querySelectorAll('li');
            ulItems.forEach(li => {
              text += `• ${htmlToFormattedText(li).trim()}\n`;
            });
            text += '\n';
            break;
            
          case 'li':
            text += htmlToFormattedText(node).trim() + '\n';
            break;
            
          case 'b':
          case 'strong':
            text += htmlToFormattedText(node); // Could add ** for markdown if wanted
            break;
            
          case 'i':
          case 'em':
            text += htmlToFormattedText(node);
            break;
            
          case 'h1':
          case 'h2':
          case 'h3':
          case 'h4':
          case 'h5':
          case 'h6':
            text += htmlToFormattedText(node).trim() + '\n\n';
            break;
            
          case 'code':
            text += '`' + htmlToFormattedText(node).trim() + '`';
            break;
            
          case 'pre':
            text += htmlToFormattedText(node).trim() + '\n\n';
            break;
            
          case 'blockquote':
            text += '> ' + htmlToFormattedText(node).trim().replace(/\n/g, '\n> ') + '\n\n';
            break;
            
          case 'hr':
            text += '---\n\n';
            break;
            
          default:
            text += htmlToFormattedText(node);
        }
      }
    }
    
    return text;
  };
  
  // Get formatted text
  let cleanText = htmlToFormattedText(tempDiv);
  
  // Clean up formatting
  cleanText = cleanText
    .replace(/\n\s*\n\s*\n/g, '\n\n')    // Max 2 consecutive newlines
    .replace(/^\s+|\s+$/g, '')           // Trim
    .replace(/\n\s+/g, '\n')             // Remove leading spaces on lines
    .replace(/\s*\n\s*/g, '\n')          // Clean whitespace around newlines
    .replace(/[ \t]{2,}/g, ' ')          // Collapse multiple spaces
    .trim();
  
  // Copy to clipboard
  navigator.clipboard.writeText(cleanText)
    .then(() => {
      showTemporaryNotification(`Message ${index + 1} copied!`);
      setCopiedIndex(index);
      
      setTimeout(() => {
        setCopiedIndex(-1);
      }, 2000);
    })
    .catch(err => {
      console.error('Copy failed:', err);
      showTemporaryNotification('Failed to copy message', 'error');
    });
};

const copySingleMessage = async (content, index) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = content;
  
  // Check if there's a table
  const tables = tempDiv.querySelectorAll('table');
  const hasTable = tables.length > 0;
  
  if (!hasTable) {
    // No table, just copy with rich formatting
    const htmlContent = createRichHTML(tempDiv);
    const plainText = extractRichText(tempDiv);
    
    // Use both formats even for non-table content
    try {
      const clipboardItem = new ClipboardItem({
        'text/html': new Blob([htmlContent], { type: 'text/html' }),
        'text/plain': new Blob([plainText], { type: 'text/plain' })
      });
      await navigator.clipboard.write([clipboardItem]);
      showTemporaryNotification(`Message ${index + 1} copied!`);
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(-1), 2000);
    } catch (err) {
      // Fallback
      await navigator.clipboard.writeText(plainText);
      showTemporaryNotification(`Message ${index + 1} copied!`);
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(-1), 2000);
    }
    return;
  }
  
  // HAS TABLE: Create both HTML and plain text with ALL formatting preserved
  const htmlContent = createRichHTMLWithTables(tempDiv);
  const plainText = extractRichTextWithTables(tempDiv);
  
  // Create clipboard item with BOTH formats
  try {
    const clipboardItem = new ClipboardItem({
      'text/html': new Blob([htmlContent], { type: 'text/html' }),
      'text/plain': new Blob([plainText], { type: 'text/plain' })
    });
    await navigator.clipboard.write([clipboardItem]);
    showTemporaryNotification(`Message ${index + 1} copied with formatting!`);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(-1), 2000);
  } catch (err) {
    console.error('Advanced copy failed:', err);
    // Fallback to plain text
    await navigator.clipboard.writeText(plainText);
    showTemporaryNotification(`Message ${index + 1} copied!`);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(-1), 2000);
  }
};

// Create rich HTML preserving ALL formatting including tables
const createRichHTMLWithTables = (element) => {
  const clone = element.cloneNode(true);
  
  // Preserve ALL formatting but clean for compatibility
  preserveFormatting(clone);
  
  // Ensure tables are copy-paste friendly
  clone.querySelectorAll('table').forEach(table => {
    // Add basic table styling for better paste experience
    table.setAttribute('border', '1');
    table.setAttribute('cellpadding', '5');
    table.setAttribute('cellspacing', '0');
    table.style.borderCollapse = 'collapse';
    
    // Ensure all formatting inside table cells is preserved
    table.querySelectorAll('th, td').forEach(cell => {
      // Keep bold for headers
      if (cell.tagName === 'TH') {
        if (!cell.querySelector('b, strong')) {
          const content = cell.innerHTML;
          cell.innerHTML = `<strong>${content}</strong>`;
        }
      }
      
      // Ensure non-empty cells
      if (!cell.innerHTML.trim()) {
        cell.innerHTML = '&nbsp;';
      }
    });
  });
  
  // Wrap in minimal HTML structure
  return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<style>
  body { font-family: Arial, sans-serif; }
  h1 { font-size: 24px; font-weight: bold; margin: 16px 0; }
  h2 { font-size: 20px; font-weight: bold; margin: 14px 0; }
  h3 { font-size: 18px; font-weight: bold; margin: 12px 0; }
  h4 { font-size: 16px; font-weight: bold; margin: 10px 0; }
  h5 { font-size: 14px; font-weight: bold; margin: 8px 0; }
  h6 { font-size: 12px; font-weight: bold; margin: 6px 0; }
  p { margin: 8px 0; line-height: 1.5; }
  ul, ol { margin: 8px 0; padding-left: 24px; }
  li { margin: 4px 0; }
  table { border-collapse: collapse; margin: 12px 0; }
  th { background-color: #f2f2f2; font-weight: bold; text-align: left; }
  th, td { border: 1px solid #ddd; padding: 8px; }
  code { background-color: #f5f5f5; padding: 2px 4px; border-radius: 3px; font-family: monospace; }
  pre { background-color: #f5f5f5; padding: 12px; border-radius: 4px; overflow-x: auto; }
  blockquote { border-left: 4px solid #ddd; margin: 8px 0; padding-left: 16px; color: #666; }
</style>
</head>
<body>
${clone.innerHTML}
</body>
</html>`;
};

// Preserve all formatting elements
const preserveFormatting = (element) => {
  // Keep these formatting tags
  const formatTags = ['b', 'strong', 'i', 'em', 'u', 's', 'strike', 'del', 'code', 'sup', 'sub'];
  
  // Convert span styles to semantic tags where possible
  element.querySelectorAll('span').forEach(span => {
    const style = span.style;
    const fontWeight = style.fontWeight;
    const fontStyle = style.fontStyle;
    const textDecoration = style.textDecoration;
    
    if (fontWeight === 'bold' || parseInt(fontWeight) >= 700) {
      const strong = document.createElement('strong');
      strong.innerHTML = span.innerHTML;
      span.parentNode.replaceChild(strong, span);
    } else if (fontStyle === 'italic') {
      const em = document.createElement('em');
      em.innerHTML = span.innerHTML;
      span.parentNode.replaceChild(em, span);
    } else if (textDecoration && (textDecoration.includes('underline') || textDecoration.includes('line-through'))) {
      if (textDecoration.includes('line-through')) {
        const del = document.createElement('del');
        del.innerHTML = span.innerHTML;
        span.parentNode.replaceChild(del, span);
      } else if (textDecoration.includes('underline')) {
        const u = document.createElement('u');
        u.innerHTML = span.innerHTML;
        span.parentNode.replaceChild(u, span);
      }
    }
  });
  
  // Remove empty elements but keep formatting
  element.querySelectorAll('p:empty, div:empty').forEach(el => {
    if (!el.innerHTML.trim()) {
      el.remove();
    }
  });
};

// Extract rich text with formatting indicators
const extractRichTextWithTables = (element) => {
  const walker = (node, inTable = false) => {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent || '';
    }
    
    if (node.nodeType !== Node.ELEMENT_NODE) {
      return '';
    }
    
    const tagName = node.tagName.toLowerCase();
    const children = Array.from(node.childNodes);
    
    switch (tagName) {
      // Headers - make them stand out
      case 'h1':
        return '\n' + '='.repeat(50) + '\n' + 
               children.map(c => walker(c, inTable)).join('').toUpperCase() + 
               '\n' + '='.repeat(50) + '\n\n';
      case 'h2':
        return '\n' + '-'.repeat(40) + '\n' + 
               children.map(c => walker(c, inTable)).join('').toUpperCase() + 
               '\n' + '-'.repeat(40) + '\n\n';
      case 'h3':
        return '\n' + children.map(c => walker(c, inTable)).join('').toUpperCase() + '\n\n';
      case 'h4':
      case 'h5':
      case 'h6':
        return '\n' + children.map(c => walker(c, inTable)).join('') + '\n\n';
        
      // Paragraphs and blocks
      case 'p':
        return children.map(c => walker(c, inTable)).join('') + '\n\n';
      case 'div':
        const divContent = children.map(c => walker(c, inTable)).join('');
        return divContent.trim() ? divContent + '\n\n' : divContent;
      case 'br':
        return '\n';
        
      // Lists
      case 'ul':
        const ulItems = node.querySelectorAll('li');
        let ulText = '\n';
        ulItems.forEach(li => {
          ulText += `• ${walker(li, inTable).trim()}\n`;
        });
        return ulText + '\n';
      case 'ol':
        const olItems = node.querySelectorAll('li');
        let olText = '\n';
        olItems.forEach((li, idx) => {
          olText += `${idx + 1}. ${walker(li, inTable).trim()}\n`;
        });
        return olText + '\n';
      case 'li':
        return children.map(c => walker(c, inTable)).join('').trim() + '\n';
        
      // Formatting
      case 'b':
      case 'strong':
        return '**' + children.map(c => walker(c, inTable)).join('') + '**';
      case 'i':
      case 'em':
        return '_' + children.map(c => walker(c, inTable)).join('') + '_';
      case 'u':
        return '<u>' + children.map(c => walker(c, inTable)).join('') + '</u>';
      case 's':
      case 'strike':
      case 'del':
        return '~~' + children.map(c => walker(c, inTable)).join('') + '~~';
      case 'code':
        return '`' + children.map(c => walker(c, inTable)).join('').trim() + '`';
      case 'pre':
        return '\n```\n' + children.map(c => walker(c, inTable)).join('').trim() + '\n```\n\n';
      case 'blockquote':
        const quote = children.map(c => walker(c, inTable)).join('').trim();
        return '\n> ' + quote.replace(/\n/g, '\n> ') + '\n\n';
        
      // Tables - special handling
      case 'table':
        return '\n' + formatTableAsRichText(node) + '\n';
      case 'tr':
      case 'th':
      case 'td':
      case 'thead':
      case 'tbody':
      case 'tfoot':
        // These are handled in formatTableAsRichText
        return children.map(c => walker(c, true)).join('');
        
      default:
        return children.map(c => walker(c, inTable)).join('');
    }
  };
  
  let text = walker(element);
  
  // Clean up extra whitespace but preserve formatting
  return text
    .replace(/\n{4,}/g, '\n\n\n')
    .replace(/[ \t]{2,}/g, ' ')
    .trim();
};

// Format table as rich text with headers bolded
const formatTableAsRichText = (table) => {
  const rows = Array.from(table.querySelectorAll('tr'));
  if (rows.length === 0) return '';
  
  // Get all cell contents with their formatting
  const cellContents = rows.map(row => {
    return Array.from(row.querySelectorAll('th, td')).map(cell => {
      // Extract text with formatting markers
      const cellText = extractCellText(cell);
      return cellText.replace(/\n/g, ' ').trim();
    });
  });
  
  // Find max columns
  const maxCols = Math.max(...cellContents.map(row => row.length));
  
  // Calculate column widths
  const colWidths = Array(maxCols).fill(0);
  cellContents.forEach(row => {
    row.forEach((cell, colIndex) => {
      // Remove formatting markers for width calculation
      const plainText = cell.replace(/\*\*|\*|_|~~|`|<u>|<\/u>/g, '');
      colWidths[colIndex] = Math.max(colWidths[colIndex], plainText.length);
    });
  });
  
  // Build formatted table
  let tableText = '\n';
  
  cellContents.forEach((row, rowIndex) => {
    // Fill missing cells
    while (row.length < maxCols) row.push('');
    
    const formattedRow = row.map((cell, colIndex) => {
      // Pad cell content
      const plainText = cell.replace(/\*\*|\*|_|~~|`|<u>|<\/u>/g, '');
      return cell + ' '.repeat(Math.max(0, colWidths[colIndex] - plainText.length));
    }).join('  |  ');
    
    tableText += formattedRow + '\n';
    
    // Add separator after header row
    if (rowIndex === 0) {
      const separator = colWidths.map(width => '-'.repeat(width)).join('--+--');
      tableText += separator + '\n';
    }
  });
  
  return tableText;
};

// Extract cell text with formatting preserved
const extractCellText = (cell) => {
  const walker = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent || '';
    }
    
    if (node.nodeType !== Node.ELEMENT_NODE) {
      return '';
    }
    
    const tagName = node.tagName.toLowerCase();
    const children = Array.from(node.childNodes);
    
    switch (tagName) {
      case 'b':
      case 'strong':
        return '**' + children.map(c => walker(c)).join('') + '**';
      case 'i':
      case 'em':
        return '_' + children.map(c => walker(c)).join('') + '_';
      case 'u':
        return '<u>' + children.map(c => walker(c)).join('') + '</u>';
      case 's':
      case 'strike':
      case 'del':
        return '~~' + children.map(c => walker(c)).join('') + '~~';
      case 'code':
        return '`' + children.map(c => walker(c)).join('').trim() + '`';
      default:
        return children.map(c => walker(c)).join('');
    }
  };
  
  return walker(cell);
};

// Fallback: Simple rich HTML without tables
const createRichHTML = (element) => {
  const clone = element.cloneNode(true);
  preserveFormatting(clone);
  
  return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<style>
  body { font-family: Arial, sans-serif; }
  h1 { font-size: 24px; font-weight: bold; }
  h2 { font-size: 20px; font-weight: bold; }
  h3 { font-size: 18px; font-weight: bold; }
  strong, b { font-weight: bold; }
  em, i { font-style: italic; }
  u { text-decoration: underline; }
  s, strike, del { text-decoration: line-through; }
  code { background-color: #f5f5f5; font-family: monospace; }
  pre { background-color: #f5f5f5; padding: 10px; }
  blockquote { border-left: 3px solid #ccc; padding-left: 10px; }
</style>
</head>
<body>
${clone.innerHTML}
</body>
</html>`;
};

// Extract rich text without tables
const extractRichText = (element) => {
  const walker = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent || '';
    }
    
    if (node.nodeType !== Node.ELEMENT_NODE) {
      return '';
    }
    
    const tagName = node.tagName.toLowerCase();
    const children = Array.from(node.childNodes);
    
    switch (tagName) {
      case 'h1':
        return '\n' + '='.repeat(50) + '\n' + 
               children.map(c => walker(c)).join('').toUpperCase() + 
               '\n' + '='.repeat(50) + '\n\n';
      case 'h2':
        return '\n' + '-'.repeat(40) + '\n' + 
               children.map(c => walker(c)).join('').toUpperCase() + 
               '\n' + '-'.repeat(40) + '\n\n';
      case 'h3':
        return '\n' + children.map(c => walker(c)).join('').toUpperCase() + '\n\n';
      case 'h4':
      case 'h5':
      case 'h6':
        return '\n' + children.map(c => walker(c)).join('') + '\n\n';
      case 'p':
        return children.map(c => walker(c)).join('') + '\n\n';
      case 'div':
        const content = children.map(c => walker(c)).join('');
        return content.trim() ? content + '\n\n' : content;
      case 'br':
        return '\n';
      case 'ul':
        const ulItems = node.querySelectorAll('li');
        let ulText = '\n';
        ulItems.forEach(li => {
          ulText += `• ${walker(li).trim()}\n`;
        });
        return ulText + '\n';
      case 'ol':
        const olItems = node.querySelectorAll('li');
        let olText = '\n';
        olItems.forEach((li, idx) => {
          olText += `${idx + 1}. ${walker(li).trim()}\n`;
        });
        return olText + '\n';
      case 'li':
        return children.map(c => walker(c)).join('').trim() + '\n';
      case 'b':
      case 'strong':
        return '**' + children.map(c => walker(c)).join('') + '**';
      case 'i':
      case 'em':
        return '_' + children.map(c => walker(c)).join('') + '_';
      case 'u':
        return '<u>' + children.map(c => walker(c)).join('') + '</u>';
      case 's':
      case 'strike':
      case 'del':
        return '~~' + children.map(c => walker(c)).join('') + '~~';
      case 'code':
        return '`' + children.map(c => walker(c)).join('').trim() + '`';
      case 'pre':
        return '\n```\n' + children.map(c => walker(c)).join('').trim() + '\n```\n\n';
      case 'blockquote':
        const quote = children.map(c => walker(c)).join('').trim();
        return '\n> ' + quote.replace(/\n/g, '\n> ') + '\n\n';
      default:
        return children.map(c => walker(c)).join('');
    }
  };
  
  let text = walker(element);
  
  return text
    .replace(/\n{4,}/g, '\n\n\n')
    .replace(/[ \t]{2,}/g, ' ')
    .trim();
};

const give_response = async (response,id) => {
  const token = cookies.get("sessionToken");
  if (!token) return;

  console.log("id = " + id)

  try {
    const res = await axios.get(
      `${process.env.REACT_APP_PORTAL_DESTINATION}${response}_response/${id}`,
      { headers: { Authorization: `${token}` } }
    );
    handleSelectChat(selectedMasterID)
  } catch (err) {
    console.error("❌ Gagal Send Response:", err);
  }
};

  useEffect(() => {
    const sessionData = cookies.get("sessionData") || {};
    //console.log("session data logging");
    //console.log(sessionData);

    if (Array.isArray(sessionData.divisi)) {
      const newSources = [...internalSources]; // copy existing
      const addedKeys = new Set();

      sessionData.divisi.forEach((d) => {
        const tryAdd = (key, label) => {
          if (!addedKeys.has(key)) {
            addedKeys.add(key);
            newSources.push({ key, label });
          }
        };

        if (d.department_id == 1 || d.department_id == 7 || d.department_id == 25) {
          console.log("ict internal data enter");
          tryAdd("int-ict", "Data Internal ICT");
        }

        if (d.department_id == 7 || d.department_id == 1 || d.department_id == 25) {
          console.log("smo internal data enter");
          tryAdd("int-smo", "Data Internal SMO");
        }

        if (d.department_id == 7 || d.department_id == 25 || d.department_id == 27 || d.department_id == 1) {
          console.log("hcga internal data enter");
          tryAdd("int-hcga", "Data Internal GA");
        }

        if (d.department_id == 28 || d.department_id == 7 || d.department_id == 1 || d.department_id == 25) {
          console.log("sales internal data enter");
          tryAdd("int-sales", "Data Internal Sales");
        }

        if (d.department_id == 40 || d.department_id == 7 || d.department_id == 1) {
          console.log("trelation internal data enter");
          tryAdd("int-trelation", "Data Internal Tenant Relation");
        }

        if (d.department_id == 41 || d.department_id == 7 || d.department_id == 1) {
          console.log("hse internal data enter");
          tryAdd("int-hse", "Data Internal HSE");
        }
      });
      setInternalSources(newSources); // update state & rerender
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (modelRef.current && !modelRef.current.contains(e.target)) {
        setShowAiModelPopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleSource = (key) => {
  // 💤 Nonaktifkan sementara fitur "Pilih Semua"
  // if (key === "Pilih Semua") {
  //   setSelectedSources((prev) => {
  //     const allActive = Object.values(prev).every((v) => v === 1);
  //     const newState = {};
  //     internalSources.forEach((src) => {
  //       newState[src.key] = allActive ? 0 : 1;
  //     });
  //     setGlobeOn(!allActive);
  //     return newState;
  //   });
  //   return;
  // }

  setSelectedSources((prev) => {
    // Jika klik yang sama → matikan semuanya
    const isSameSource = prev[key] === 1;
    const newState = {};

    internalSources.forEach((src) => {
      newState[src.key] = 0; // reset semua dulu
    });

    if (!isSameSource) {
      // aktifkan yang baru diklik
      newState[key] = 1;
      setGlobeOn(true);
    } else {
      // kalau klik ulang yang sama → matikan globe
      setGlobeOn(false);
    }

    return newState;
  });
};
  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    const MAX_SIZE = 5 * 1024 * 1024; // 5 MB
    const MAX_FILES = 2;

    const combinedFiles = [...selectedFiles, ...newFiles];

    if (combinedFiles.length > MAX_FILES) {
      Swal.fire({
        icon: "warning",
        title: "Maksimal 2 File",
        text: "Kamu hanya bisa mengupload maksimal 2 file saja.",
        confirmButtonColor: "#3085d6",
      });
      e.target.value = "";
      return;
    }

    const oversizedFile = newFiles.find((f) => f.size > MAX_SIZE);
    if (oversizedFile) {
      Swal.fire({
        icon: "error",
        title: "File Terlalu Besar",
        html: `File <b>${oversizedFile.name}</b> melebihi batas ukuran 5 MB.`,
        confirmButtonColor: "#d33",
      });
      e.target.value = "";
      return;
    }

    setSelectedFiles(combinedFiles);
    e.target.value = "";
  };

  const removeFile = (index) => {
  setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
};
  const refreshMasterChatList = useCallback(async () => {
    const token = cookies.get("sessionToken");
    if (!token) return;

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_PORTAL_DESTINATION}listMaster`,
        { headers: { Authorization: `${token}` } }
      );
      setMasterChatList(res.data.masterChatList || []);
    } catch (err) {
      console.error("❌ Gagal refresh master chat:", err);
    }
  }, []);

  const autoResizeTextarea = (el) => {
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  };

  // Typing effect untuk AI
const typeWriterEffect = async (fullText, onUpdate) => {
  let i = 0;
  const speed = 10;
  while (i < fullText.length) {
    onUpdate(fullText.slice(0, i + 5));
    i += 5;
    await new Promise((r) => setTimeout(r, speed));
  }
  onUpdate(fullText);
};

const handleSendMessage = async () => {
  //reset text area
  if (textareaRef.current) {
    textareaRef.current.style.height = "auto";
  }
  
  if (message.trim() === "" && selectedFiles.length === 0) return;
  
  const userMsg = message.trim();

  // === Tentukan statusInternal numeric ===
  const internalMap = {
    "int-befa": 1,
    "int-ict": 2,
    "int-smo": 3,
    "int-hcga": 4,
    "int-sales": 5,
    "int-trelation": 6,
    "int-hse": 7,
  };

  let statusInternal = undefined; // default 0 (tidak ada yang dipilih)
  const selectedInternal = Object.entries(selectedSources).find(
    ([key, val]) => val === 1 && key.startsWith("int-")
  );
  if (selectedInternal) {
    statusInternal = internalMap[selectedInternal[0]] ;
  }

  console.log("🚩 Selected Internal Source:", statusInternal);

  // Create user message with files
  const userMessage = {
    sender: "user", 
    content: userMsg, 
    time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
    files: [...selectedFiles] // Store the actual File objects for preview
  };

  // Add user message to chatList
  setChatList((prev) => [...prev, userMessage]);
  setMessage("");
  setSelectedFiles([]); // Clear files after sending
  setIsTyping(true);

  try {
    const token = cookies.get("sessionToken");
    const formData = new FormData();
    formData.append("message", userMsg);
    formData.append("masterID", selectedMasterID || 0);
    // ✅ masukkan statusInternal dinamis (null jika tidak ada internal dipilih)
    formData.append("statusInternal", statusInternal || "");
    formData.append("aiModel", selectedAiModel);

    selectedFiles.forEach((file) => formData.append("upload", file));

    const res = await axios.post(
      `${process.env.REACT_APP_PORTAL_DESTINATION}chat`,
      formData,
      { headers: { Authorization: `${token}` } }
    );

    if (res.data.masterID && !selectedMasterID) {
      setSelectedMasterID(res.data.masterID);
    }

    refreshMasterChatList();

    const aiText = res.data.answer || res.data.aiMessage || "Tidak ada respons dari AI.";

    // Create AI message
    let aiIndex;
    setChatList((prev) => {
      aiIndexRef.current = prev.length;
      return [
        ...prev,
        {
          id: res.data.id,
          sender: "ai",
          good_response: 0,
          bad_response: 0,
          content: "",
          time: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
          files: [],
        },
      ];
    });

    setIsTyping(false);
    
    await typeWriterEffect(aiText, (partial) => {
  setChatList((prev) =>
    prev.map((item, idx) =>
      idx === aiIndexRef.current
        ? { ...item, content: partial }
        : item
    )
  );
});
  } catch (err) {
    setIsTyping(false);

    // 🔥 PROMPT TOO LONG
    if (
      err.response &&
      err.response.status == 413 &&
      err.response.data?.errorType == "PROMPT_TOO_LONG"
    ) {
      setChatList((prev) => [
        ...prev,
        {
          sender: "system",
          content: `
  <strong>⚠️ File terlalu besar untuk diproses</strong><br/>
  File yang Anda unggah mengandung data yang sangat besar sehingga melebihi batas pemrosesan AI.<br/><br/>
  <strong>Solusi:</strong>
  <ul style="margin:6px 0 0 18px">
    <li>Bagi file menjadi beberapa bagian</li>
    <li>Unggah satu per satu melalui chat baru</li>
  </ul>
  <br/>
Kami telah mengetahui keterbatasan ini dan sedang melakukan pembaruan berkelanjutan pada sistem AI secara berkala agar kendala serupa dapat diminimalkan ke depannya.
  `,
          time: new Date().toLocaleTimeString("id-ID", {
            hour: "2-digit",
            minute: "2-digit",
          }),
        },
      ]);

      return; // ⛔ STOP total
    }

    // ❌ ERROR LAIN
    setChatList((prev) => [
      ...prev,
      {
        sender: "system",
        content: "<i>⚠️ Terjadi kesalahan saat menghubungi AI.</i>",
        time: new Date().toLocaleTimeString("id-ID", {
          hour: "2-digit",
          minute: "2-digit",
        }),
      },
    ]);
  } finally {
    setIsTyping(false);
  }
};

  const handleKeyDown = async (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  useEffect(() => {
    refreshMasterChatList();
    console.log("🔄 Refreshing master chat list...");

    const fetchPrompt = async () => {
      const token = cookies.get("sessionToken");
      if (!token) return;

      try {
        const promptRes = await axios.get(`${process.env.REACT_APP_PORTAL_DESTINATION}getPromptSuggest`, {
          headers: { Authorization: `${token}` },
        });
        setPromptSuggest(promptRes.data.prompts || []);
      } catch (err) {
        console.error("Error fetching prompt:", err);
      }
    };

    fetchPrompt();
  }, [refreshMasterChatList]);

  // Replace the current useEffect that fetches chat history
  useEffect(() => {
    if (!selectedMasterID) {
      setChatList([]);
      return;
    }
    handleSelectChat(selectedMasterID)
  }, [selectedMasterID]);

  const handleSelectChat = async (chatId) => {
    setSelectedMasterID(chatId);
    const token = cookies.get("sessionToken");
    if (!token) {
      console.warn("❌ No token found!");
      return;
    }

    try {
      const res = await axios.get(`${process.env.REACT_APP_PORTAL_DESTINATION}chat/${chatId}`, {
        headers: { Authorization: `${token}` },
      });
     
      const { chatHistory } = res.data;

      if (!chatHistory || chatHistory.length === 0) {
        setChatList([]);
        return;
      }

      
      // Transform the API response to include files in messages
const formatted = chatHistory.flatMap((item) => {
  const userMessage = {
    id: item.id,  // This ID is for the chat record
    chatRecordId: item.id,  // Store the chat record ID separately
    good_response: item.good_response,
    bad_response: item.bad_response,
    sender: "user",
    content: item.prompt || "",
    time: new Date(item.created_at).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    }),
    files: [], // Initialize empty files array
    fileNames: [] // Initialize empty file names array
  };

  const aiMessage = {
    id: `ai-${item.id}`,  // Add prefix to make it unique for AI messages
    chatRecordId: item.id,  // Store the original chat record ID
    good_response: item.good_response,
    bad_response: item.bad_response,
    sender: "ai",
    content: item.ai_answer || "",
    time: new Date(item.created_at).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    }),
    files: []
  };

  // Add file information to user message if files exist
  if (item.file_uploaded) {
    userMessage.files = [item.file_uploaded];
    userMessage.fileNames = [item.file_name_show || "file"];
    
    if (item.file_uploaded2) {
      userMessage.files.push(item.file_uploaded2);
      userMessage.fileNames.push(item.file_name_show2 || "file2");
    }
  }

  return [userMessage, aiMessage];
});

      setChatList(formatted);
    } catch (err) {
      console.error("❌ Gagal ambil chat detail:", err);
    }
  };

  const resetChat = () => {
    setMessage("");
    setChatList([]);
    setSelectedMasterID(0);
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.focus();
    }
  };

  const activeSourcesCount = Object.values(selectedSources).filter((v) => v === 1).length;

  return (
    <div className=" font-befa chat-wrapper" style={{fontFamily:'Montserrat !important'}}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        masterChatList={masterChatList}
        onNewChat={resetChat}
        userData={userData}
        refreshMasterChatList={refreshMasterChatList}
        onSelectChat={handleSelectChat}
      />

      <div className={`chat-main ${collapsed ? "collapsed" : ""}`} style={{fontFamily:'Montserrat'}}>
        <div className="welcome">
          {chatList.length === 0 ? (
            <h1 style={{ fontFamily: 'Exo', marginTop: '30px' }}>
              <span style={{ fontFamily: 'Exo' }}>
                Selamat datang di BeFa Insight ✨
              </span>
            </h1>
          ) : (
            <h1 style={{ fontFamily: 'Exo', marginTop: '0px' }}>
              <span style={{ fontFamily: 'Exo' }}>
                BeFa Insight
              </span>
            </h1>
          )}

          { chatList.length === 0 && (
            <div style={{marginTop:'30px'}}>
              {false && showUpdate && (
                <div className="update-box">
                  <button className="close-btn" onClick={() => setShowUpdate(false)}>
                    <X size={14} />
                  </button>
                  <table className="update-layout">
                    <tbody>
                      <tr>
                        <td className="icon-cell">
                          <LightBulbOn width={40} height={40} />

                        </td>
                        <td className="content-cell">
                          <p>
                            <strong>Update:</strong> BeFa Insight kini dilengkapi SOP semua departemen serta sumber data internal, sehingga dapat menjadi referensi untuk mendukung kebutuhan kerja sesuai bidang masing-masing. Untuk penambahan data internal, silakan hubungi tim ICT.
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
              <div className="quick-actions" style={{ marginBottom: "3.6vw", marginTop:showUpdate?'0px':'50px'}}>
                {promptSuggest.length > 0 ? (
                  promptSuggest
                    .filter((item) => item.public === 0)
                    .map((item, idx) => (
                      <button
                        key={idx}
                        type="button"
                        onClick={() => {
                          setMessage(item.prompt || "");
                          if (textareaRef.current) {
                            textareaRef.current.style.height = "auto";
                            autoResizeTextarea(textareaRef.current);
                            textareaRef.current.focus();
                          }
                        }}
                      >
                        {item.prompt || "Prompt"}{" "}
                        <img src="/dist/img/right-round-arrow.png" style={{ width: "20px" }} />
                      </button>
                    ))
                ) : (
                  <p>Loading prompt...</p>
                )}
              </div>
              <div className="update-button-box"> 
                <button className="update-button" style={{ marginRight: '20px' }} 
                  onClick={() => window.open('https://befanetid.sharepoint.com/sites/BEFADIGITAL/Modul%20Training/Forms/AllItems.aspx?id=%2Fsites%2FBEFADIGITAL%2FModul%20Training%2F33%2E%20Dokumentasi%20BeFa%20AI%20Chatbot%2FBeFa%20AI%20Chatbot%20Documentation%201%2E1%2Epdf&parent=%2Fsites%2FBEFADIGITAL%2FModul%20Training%2F33%2E%20Dokumentasi%20BeFa%20AI%20Chatbot', '_blank')} >
                  <InfoCircle className="btn-icon" />
                  Tutorial & Dokumentasi
                  <span className="btn-arrow">
                    <ArrowUpRight />
                  </span>
                </button>

                <button className="update-button"
                  onClick={() => window.open('https://befanetid.sharepoint.com/sites/BEFADIGITAL/SitePages/Update-BeFa-AI-&-Panduan-Praktis.aspx?csf=1&web=1&e=WdqOrc&CID=a611e229-6294-4eb0-af9a-df29bde8e4db', '_blank')} >
                  <PageFlip className="btn-icon" />
                  Artikel AI Terbaru
                  <span className="btn-arrow">
                    <ArrowUpRight />
                  </span>
                </button>

              </div>
            </div>
          )}
        </div>
        
        <div className="rightScroll">
        {chatList.length > 0 && (
          <div id="chat-container" className="chat-messages">
            {chatList.map((chat, idx) => (
              <div key={`chat-${idx}`}>
                {/* File previews */}
                {chat.files && chat.files.length > 0 && (
                  <div style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start'}}>
                    {chat.files.map((file, fileIndex) => 
                      file && renderFilePreview(
                        file, 
                        true, 
                        fileIndex, 
                        idx,
                        // Safe access to fileNames array
                        (chat.fileNames && chat.fileNames[fileIndex]) || 
                        (file instanceof File ? file.name : 
                        typeof file === 'string' ? file.split('/').pop() : 
                        file.fileName || "unknown")
                      )
                    )}
                  </div>
                )}
            
                {/* Container for chat bubble + copy button */}
                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                  {/* Chat bubble */}
                  <div
                    className={`chat-bubble ${chat.sender === "user" ? "user-bubble" : "ai-bubble"}`}
                  >
                    <div
                      className="chat-content"
                      dangerouslySetInnerHTML={{ __html: chat.content }}
                    />
                    <div className={chat.sender === "user" ? "chat-time":"chat-time-ai"}>{chat.time}</div>
                  </div>
                </div>

                {/* Copy button - new line, right-aligned */}
                <button 
                  style={{
                    display: 'block',
                    marginLeft: chat.sender === "user"? 'auto':'12px',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '10px',
                    color: '#737E86',
                    marginTop: chat.sender === "user"? '-12px':'-20px',
                  }}
                >
                  {copiedIndex === idx ? (
                    <div className="tooltip-container">
                      <Check className="hoverclass" />
                      <span className="tooltip-text">Copied!</span>
                    </div>
                  ) : (
                    <div className="tooltip-container">
                      <Copy
                        className="hoverclass"
                        onClick={() => copySingleMessage(chat.content, idx)}
                      />
                      <span className="tooltip-text">Copy message</span>
                    </div>
                  )}
                  
                  {chat.sender != "user" && (<>
                    {((chat.good_response == 0 && chat.bad_response == 0) || chat.good_response == 1) && (
                      <div className="tooltip-container">
                        <ThumbsUp 
                          onClick={() =>give_response("good",chat.chatRecordId || chat.id)}
                          className={chat.good_response === 1? "hoverclass chosen" : "hoverclass"}
                          style={{margin:'0px 2px'}}
                        />
                        <span className="tooltip-text">Good Response</span>
                      </div>
                    )}
                    {((chat.bad_response == 0 && chat.good_response == 0)|| chat.bad_response == 1) && (
                      <div className="tooltip-container">
                        <ThumbsDown 
                          onClick={() => give_response("bad",chat.chatRecordId || chat.id)}
                          className={chat.bad_response === 1? "hoverclass chosen" : "hoverclass"}
                        />
                        <span className="tooltip-text">Bad Response</span>
                      </div>
                    )}
                  </>)}
                </button>

                <br />
              </div>
            ))}

            {isTyping && (
              <div className="typing-indicator">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
              </div>
            )}
          </div>
        )}

        </div>

        {/* Chat Input */}
        <div className="chat-input-wrapper">
          <div className="chat-input-inner">
            {(selectedFiles.length > 0 || selectedFiles2.length > 0) && (
              <div className="file-preview-inline">
                {[...selectedFiles, ...selectedFiles2].map((file, idx) => (
                  <div key={idx} className="file-item">
                    {renderFilePreview(file, true)}
                    <button type="button" className="remove-file-btn" onClick={() => removeFile(idx)}>
                    ×
                    </button>
                  </div>
                ))}
              </div>
            )}

            <div className="input-row">
              <div className="globe-container" ref={menuRef}>
                <div
                  className="globe-wrapper"
                  onMouseEnter={() => setHovered(true)}
                  onMouseLeave={() => setHovered(false)}
                >
                <Internet 
                  onClick={() => setMenuOpen(!menuOpen)}
                  style={{
                     cursor: "pointer",
                     width: "28px",
                     height: "28px",
                     transition: "filter 0.2s ease",
                     color: "#08a6e4",
                  }}
                  className="internet-status-icon" 
                  /> 
                  {hovered && !menuOpen && <div className="globe-tooltip">Pilih Sumber Data Khusus</div>}
                </div>

                {menuOpen && (
                  <div className="data-source-menu">
                    {/* <div className="menu-item-int" onClick={() => toggleSource("Pilih Semua")}>
                      Pilih Semua
                      {Object.values(selectedSources).filter((v) => v === 1).length === internalSources.length && (
                        <span className="check">✓</span>
                      )}
                    </div> 
                    <hr />*/}
                    {internalSources.map(({ key, label }) => (
                      <div key={key} className="menu-item-int" onClick={() => toggleSource(key)}>
                        {label}
                        {selectedSources[key] === 1 && <span className="check">&nbsp;✓</span>}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              
              {showAiModelPopup && (
                <div ref={modelRef} className="aiModel-overlay" onClick={() => setShowAiModelPopup(false)}>
                  <div
                    className="aiModel-popup"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {aiModelPick.map((item) => {
                      const isActive = item.key === selectedAiModel;

                      return (
                        <div
                          key={item.key}
                          className={`aiModel-item ${isActive ? "active" : ""}`}
                          onClick={() => {
                            setSelectedAiModel(item.key);
                            setShowAiModelPopup(false);
                          }}
                        >
                          <div className="aiModel-text">
                            <div className="aiModel-label">{item.label}</div>
                            <div className="aiModel-detail">{item.detail}</div>
                          </div>

                          {isActive && <div className="aiModel-check">✔</div>}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

                <div className="aiModel globe-container">
                  <div
                    className="aiModel-trigger globe-wrapper"
                    onClick={() => setShowAiModelPopup(!showAiModelPopup)}
                    onMouseEnter={() => setModelHovered(true)}
                    onMouseLeave={() => setModelHovered(false)}
                  >
                    {modelHovered && !showAiModelPopup && <div className="globe-tooltip">Pilih Model AI</div>}
                    {selectedModel?.label} <NavArrowDown />
                  </div>
                </div>

              <textarea
                ref={textareaRef}
                id="chatTextarea"
                name="message"
                placeholder="Tulis sesuatu..."
                rows="1"
                value={message}
                onChange={(e) => {
                  setMessage(e.target.value);
                  autoResizeTextarea(e.target);
                }}
                onKeyDown={handleKeyDown}
                required
              />

              <div className="tooltip-wrapper">
                <Attachment size={27} className="input-icon-right" onClick={() => document.getElementById("file-upload").click()} />
                <span className="tooltip-text">Pilih Attachment</span>
              </div>
              <input
                id="file-upload"
                type="file"
                name="upload"
                multiple
                accept=".txt,.csv,.json,.sql,.md,.html,.xml,.xlsx,.pdf,.docx,.doc,.pptx,.jpg,.jpeg,.png,.bmp,.webp,.gif"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />

              <button className="send-btn" onClick={handleSendMessage} disabled={message.trim() === ""}>
                <img
                  src={message.trim() === "" ? "/dist/img/send-grey.png" : "/dist/img/send-black.png"}
                  alt="Send"
                  style={{ width: "30px", opacity: message.trim() === "" ? 0.6 : 1, transition: "opacity 0.2s ease" }}
                />
              </button>
            </div>
          </div>

          <div className="selected-info">
            {activeSourcesCount > 0 && (
              <>
                <img src="/dist/img/search-biru.png" style={{ width: "25px", marginRight: "8px" }} alt="Search" />
                <span>Cari dari :</span>
                {/* 
                <div className="source-box" onClick={() => setShowSources(!showSources)}>
                  <img src="/dist/img/internet-biru.png" style={{ width: "20px", marginRight: "6px" }} alt="Internet" />
                  {activeSourcesCount} Sumber Aktif
                </div>
                */}
                {true && (
                  <div className="source-list">
                    {Object.entries(selectedSources)
                      .filter(([_, value]) => value === 1)
                      .map(([key]) => {
                        const sourceLabel = internalSources.find((s) => s.key === key)?.label || key;
                        return (
                          <div key={key} className="source-item">
                            <img src="/dist/img/internet-biru.png" style={{ width: "20px", marginRight: "6px" }} alt="Internet" />
                            <button
                              className="remove-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedSources((prev) => ({ ...prev, [key]: 0 }));
                              }}
                            >
                              X
                            </button>
                            <span className="source-text">{sourceLabel}</span>
                          </div>
                        );
                      })}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chat;
